"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonEmptyMenuItem = void 0;
/**
 * @internal
 *
 * Return a bool value based on if the a Menu item is a a valid item, or have valid sub-items.
 *
 * @param {TMenuItem} item - The menu item to filter.
 * @returns {boolean} - Returns true if the item is non-empty, false otherwise.
 *
 * @remarks
 * This function recursively checks the nested structure of the MenuItem
 * to determine if it contains any empty groups or catagories. If any non-empty
 * items are found within categories, groups, or user, the function returns true.
 * Empty categories, groups, and users (with no child items) are considered as empty items
 * and are filtered out from the menu.
 */
const isNonEmptyMenuItem = (item) => {
    // If group has any items, return true;
    if (item?.kind === "group")
        return item?.items?.length > 0;
    // If user section has any items, return true;
    if (item.kind === "user")
        return item?.items?.length > 0;
    // If category has any non-empty items return true.
    if (item?.kind === "category")
        return item?.items?.filter(exports.isNonEmptyMenuItem)?.length > 0;
    // All other kinds (links, logos, search), return true.
    return true;
};
exports.isNonEmptyMenuItem = isNonEmptyMenuItem;
